import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon, Menus, Text, Link } from '@Sage/hoi-poi-ui';

import { Core } from 'managers';
import { bindActionCreators } from 'redux';
import { AuthenticationActions } from 'actions';
import Loader from 'components/loader';
import RoundedImg from 'components/rounded-image';
import { t } from 'utils/getLiteral';
import { WEBAPP_URL } from 'constants/Environment';
import { SETUP_ROL_BUSINESS, SETUP_ROL_SMALL_BUSINESS } from 'constants/App';

import './styles.scss';

function mapStateToProps({ authentication, ...state }) {
    return {
        user: authentication.user || {},
        state,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        logout: bindActionCreators(AuthenticationActions, dispatch).logout,
    };
}

/**
 * Profile Holder component.
 */
class ProfileHolder extends Component {
    constructor(props) {
        super(props);
        this.imgRef = React.createRef();
    }

    renderLoading = () => (
        <div className="d-table h-100 w-100">
            <div className="profile-holder d-table-cell align-middle text-right">
                <div className="float-right">
                    <Loader size="medium" />
                </div>
            </div>
        </div>
    );

    getItems = () => {
        const { user } = this.props;
        const items = [
            {
                title: (
                    <div className="profile__user-name">
                        <Text bold isTruncated>{`${user.name} ${user.surname}`}</Text>
                    </div>
                ),
                icon: (
                    <div>
                        <Icon name="emptyAvatar" size="medium" />
                    </div>
                ),
                infoItem: true,
            },
            {
                title: (
                    <div className="profile__logout--text">
                        <Text>{t('cfm_action_logout')}</Text>
                    </div>
                ),
                icon: (
                    <div className="profile__logout--icon">
                        <Icon name="exitToApp" size="medium" />
                    </div>
                ),
                onClick: () => this.props.logout(),
            },
        ];

        return items;
    };

    goToWebApp = () => {
        const { user } = this.props;
        let url;
        const token = Core.cacheManager.getTokenStore();

        if (
            window.location.host.includes('adminsta') ||
            window.location.host.includes('localhost')
        ) {
            url = 'https://app-sta.forcemanager.net/';
        } else if (window.location.host.includes('adminpre')) {
            url = 'https://app-pre.forcemanager.net/';
        } else {
            url = `${WEBAPP_URL}/`;
        }

        url = `${url}?user=${encodeURIComponent(user.email)}&token=JWT ${token}#/auth`;
        window.location.href = url;
    };

    render() {
        const { user } = this.props;

        const showGoToWeb =
            user.canLoginWeb &&
            [SETUP_ROL_BUSINESS, SETUP_ROL_SMALL_BUSINESS].includes(user.idSetupRol);

        if (user === undefined || Object.keys(user).length === 0) {
            return this.renderLoading();
        }
        return (
            <div>
                <div className="profile-holder">
                    {showGoToWeb && (
                        <span className="profile-holder__button">
                            <Link size="small" onClick={this.goToWebApp}>
                                {t('cfm_action_go_to_forcemanager')}
                            </Link>
                        </span>
                    )}
                    <div className="profile-holder__user-name">
                        <Menus
                            classNameMenu="profile__submenu"
                            size="large"
                            icon={
                                <RoundedImg
                                    ref={this.imgRef}
                                    className="foto"
                                    alt={`${user.name} ${user.surname}`}
                                    src={user.photo ? `data:image/png;base64,${user.photo}` : ''}
                                    diameter={32}
                                />
                            }
                            items={this.getItems()}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ProfileHolder.propTypes = {
    user: PropTypes.shape({}),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHolder);
